import type TemplateAssignmentView from '@UI/Store/DocumentTemplates/Views/TemplateAssignements/TemplateAssignmentView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * `list` always holds one entry per non-archived document type of the account, in the server's
 * order (system types first, then free types by label), including document types with no
 * assignment at all. Not built on `AbstractListView`: entries have no numeric `id` of their own,
 * they are keyed by `documentTypeId` (mirrors `ModelAssignmentsListView`). `scopeId` names the
 * resource this instance belongs to regardless of `scopeType` — the organization or the facility.
 */
class TemplateAssignmentsListView {
	readonly list: readonly TemplateAssignmentView[];
	readonly scopeId: number;
	readonly scopeType: 'organization' | 'facility';

	constructor(
		list: readonly TemplateAssignmentView[],
		scopeId: number,
		scopeType: 'organization' | 'facility',
	) {
		this.list = list;
		this.scopeId = scopeId;
		this.scopeType = scopeType;

		Object.freeze(this);
	}

	findByDocumentTypeId(documentTypeId: number): TemplateAssignmentView | null {
		return this.list.find((entry) => entry.documentTypeId === documentTypeId) ?? null;
	}
}

export default TemplateAssignmentsListView;
